export const socialNetworks = [
  'facebook',
  'instagram',
  'linkedIn',
  'twitter',
] as const;

export type TLinkType = typeof socialNetworks[number];

export interface IUsersAuthor {
  companyName?: string;
  facebook?: string;
  instagram?: string;
  jobTitle?: string;
  linkedIn?: string;
  profilePhoto?: {
    link?: string;
    mediaItemUrl?: string;
    sizes?: string;
    sourceUrl?: string;
    srcSet?: string;
  };
  twitter?: string;
}
export interface IAuthorInfo {
  description?: string;
  name: string;
  firstName?: string;
  lastName?: string;
  usersAuthor: IUsersAuthor;
  url?: string;
  uri?: string;
}

export interface IAuthors {
  nodes: IAuthorInfo[];
}

export interface IAuthorProps {
  author: IAuthorInfo;
  className?: string;
  isArchive?: boolean;
}

export interface IAuthorsLayout {
  authors: IAuthorInfo[];
  isArchive?: boolean;
}

export interface IStaticAuthorsLayout {
  authors: IAuthorInfo[];
  className?: string;
  isArchive?: boolean;
  noTableOfContents?: boolean;
}
